import React, { Component } from 'react'

import {
  MdInfo,
  MdReportProblem,
  MdCheckCircle,
  MdError,
  MdNotifications,
} from "react-icons/md";
import { PopupAlertTheme } from "../../interfaces/popupAlert";
import { StoreState } from "../../reducers";
import { RemovePopupAlert, PushPopupAlert, System } from "../../actions";
import { connect } from "react-redux";

interface PopupAlertState {}

export interface PopupAlertData {
  title: string;
  description?: string;
  theme: PopupAlertTheme;
}

export interface PopupAlert {
  title: string;
  description?: string;
  theme: PopupAlertTheme;
  successFn?: Function;
  timeOut?: boolean;
  RemovePopupAlert: () => void;
}

class _Popup extends Component<PopupAlert, PopupAlertState> {
  componentDidMount = () => {
    setTimeout(() => {
      this.props.RemovePopupAlert();
    }, 5000);
  }
  render() {
    let Icon: any;

    if (this.props.theme === PopupAlertTheme.danger) {
      Icon = MdReportProblem;
    } else if (this.props.theme === PopupAlertTheme.info) {
      Icon = MdInfo;
    } else if (this.props.theme === PopupAlertTheme.success) {
      Icon = MdCheckCircle;
    } else if (this.props.theme === PopupAlertTheme.warning) {
      Icon = MdError;
    } else {
      Icon = MdNotifications;
    }
    return (
      <div onClick={() => this.props.RemovePopupAlert()} className={`alert-${this.props.theme} mb-3 animate__animated animate__bounceInUp`} role="alert" style={{zIndex: 999999999}}>
        <div className="flex">
          <div className="py-1">
            <Icon className="fill-current h-6 w-6 text-green-500- opacity-60 mr-4" />
          </div>
          <div>
            <p className="font-bold">{!this.props.title ? "Alert" : this.props.title}</p>
            {!this.props.description ? null : <p className="text-sm">{this.props.description}</p>}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  system,
}: StoreState): {
  system: System;
} => {
  return {
    system: system,
  };
};

const Popup = connect(mapStateToProps, {
  RemovePopupAlert,
  PushPopupAlert,
})(_Popup);

export default Popup;